import React from 'react';

import { ModalKeys } from '../../context/modals';
import { parameters, strings } from '../../localization/strings';
import ModalText from './text-modal';
import ExternalText from '../text/external-text';
import { useSite } from '../../hooks/use-site';
import TextTerms from '../text/self-co-terms';

export default function ModalTermsConditions() {
  const { isSelfCo } = useSite();

  return (
    <ModalText type={ModalKeys.Terms} title={strings()?.textPage?.termsAndConditions?.title || 'Terms and Conditions'}>
      {isSelfCo ? <TextTerms /> : <ExternalText url={parameters()?.textPage?.terms} />}
    </ModalText>
  );
}
